export default {
  setFiles(state, files) {
    state.files = files;
  },
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  setLesson(state, lesson) {
    state.lesson = lesson;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
